.root {
  align-items: center;
  display: flex;
  gap: 8px;
  width: 100%;
}

// The Select renders a relatively-positioned wrapper around its trigger;
// `className` lands on the inner button, so stretch the wrapper (the flex
// item) here to make the field span the row's full width.
.root > *:first-child {
  flex: 1 1 auto;
  min-width: 0;
}
